module.exports = __webpack_public_path__ + "e12d639ebf8b093aca396b578455b030.png";